import React, { useState } from 'react';
import { addNewItem } from '../../utils/dataHandlers';

const AddItemForm = ({ activeSection, user, onSubmitSuccess, onCancel }) => {
  const [newTopic, setNewTopic] = useState('');
  const [newQuestion, setNewQuestion] = useState('');
  const [newAnswer, setNewAnswer] = useState('');
  const [newUtterance, setNewUtterance] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addNewItem(activeSection, {
        topic: newTopic,
        question: newQuestion,
        answer: newAnswer,
        text: newUtterance,
        addedBy: user.email,
      });
      onSubmitSuccess();
      onCancel();
    } catch (error) {
      console.error(`Error adding ${activeSection}:`, error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mt-4 p-4 bg-gray-100 rounded">
      <h3 className="text-lg font-semibold mb-2">
        Add New {activeSection === 'faq' ? 'FAQ' : activeSection === 'utterance' ? 'Utterance' : 'Answer'}
      </h3>
      <input
        type="text"
        placeholder="Topic"
        value={newTopic}
        onChange={(e) => setNewTopic(e.target.value)}
        className="w-full p-2 mb-2 border rounded"
        required
      />
      {activeSection === 'faq' ? (
        <>
          <input
            type="text"
            placeholder="Question"
            value={newQuestion}
            onChange={(e) => setNewQuestion(e.target.value)}
            className="w-full p-2 mb-2 border rounded"
            required
          />
          <textarea
            placeholder="Answer"
            value={newAnswer}
            onChange={(e) => setNewAnswer(e.target.value)}
            className="w-full p-2 mb-2 border rounded"
            required
          />
        </>
      ) : activeSection === 'utterance' ? (
        <input
          type="text"
          placeholder="Utterance"
          value={newUtterance}
          onChange={(e) => setNewUtterance(e.target.value)}
          className="w-full p-2 mb-2 border rounded"
          required
        />
      ) : (
        <textarea
          placeholder="Answer"
          value={newAnswer}
          onChange={(e) => setNewAnswer(e.target.value)}
          className="w-full p-2 mb-2 border rounded"
          required
        />
      )}
      <button type="submit" className="bg-green-500 text-white px-4 py-2 rounded">
        Add {activeSection === 'faq' ? 'FAQ' : activeSection === 'utterance' ? 'Utterance' : 'Answer'}
      </button>
    </form>
  );
};

export default AddItemForm;
